import Dashboard from '../containers/dashboard'
import DocumentPaymentsDetailsManagement from '../containers/document-payments-details-management'

const DocumentPaymentsDetails = () => {
  return (
    <Dashboard>
      <DocumentPaymentsDetailsManagement />
    </Dashboard>
  )
}

export default DocumentPaymentsDetails
